import Model, { attr, belongsTo } from '@ember-data/model';
import type TasApplicationModel from './tas-application';
import type TASProgramInstanceModel from './tas-program-instance';
import type TASCourseModel from './tas-course';
export default class TasFieldModel extends Model {
  @attr declare name: string;
  @attr declare values: string[] | null;
  @attr declare label: string | null;
  @attr declare fieldType: string;
  @attr declare dataType: string;
  @attr declare required: boolean;
  @attr declare visible: boolean;
  @attr declare options: Record<string, unknown>[] | null;
  @attr declare validations: Record<string, unknown> | null;
  @attr declare helpText: string | null;
  @attr declare placeholder: string | null;
  @attr declare sortOrder: number | null;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;
  @attr declare flavor: string;
  @attr declare ordinal: number;
  @attr declare province: string;

  @belongsTo('tas-application', { async: false, inverse: 'tasFields' })
  declare tasApplication: TasApplicationModel;
  @belongsTo('tas-program-instance', { async: false, inverse: 'tasFields' })
  declare tasProgramInstance: TASProgramInstanceModel;
  @belongsTo('tas-course', { async: false, inverse: 'tasFields' })
  declare tasCourse: TASCourseModel;

  // Computed property to get the first value (for single-value fields)
  get value(): string | null {
    return this.values?.[0] || null;
  }

  // Computed property to check if field has a value
  get hasValue(): boolean {
    return this.values !== null && this.values.length > 0;
  }
}
